import {
  Arr
} from '../../../../lib/Array.lib';
import {
  NOT
} from '../../../../lib/Boolean.lib';
import Definition, {
  DEFINITION_CATEGORY__TECHNICAL_SKILLS
} from '../../../../lib/Definition';
import {
  Obj
} from '../../../../lib/Object.lib';
import {
  COLLECTION__JOBS,
  readLoopbackRecord
} from '../../../../lib/services/BE/loopback.api';

const cache = {};

export async function fetchJobSkills({
  jobId
}) {
  if (NOT(jobId)) { return {}; }
  if (NOT(cache[jobId])) {
    cache[jobId] = Obj(
      await readLoopbackRecord({
        collection: COLLECTION__JOBS,
        where: { id: jobId },
        limit: 1,
        fields: ['technicalSkills']
      })
    );
  }
  return cache[jobId];
}

export async function fetchTagIdJobSkills({
  jobId
}) {
  return Arr(
    Obj(
      await fetchJobSkills({ jobId })
    ).technicalSkills
  );
}

export async function fetchTagLabelJobSkills({
  jobId
}) {
  return Definition.getLabels(
    DEFINITION_CATEGORY__TECHNICAL_SKILLS,
    await fetchTagIdJobSkills({ jobId })
  );
}
